export default {
  'application.title': 'Pensjonskalkulator - Pensjon',
  'application.title.stegvisning.start': 'Start - Pensjonskalkulator',
  'application.title.stegvisning.sivilstand': 'Sivilstand - Pensjonskalkulator',
  'application.title.stegvisning.utenlandsopphold':
    'Utanlandsopphald - Pensjonskalkulator',
  'application.title.stegvisning.afp': 'AFP - Pensjonskalkulator',
  'application.title.stegvisning.ufoeretryg_AFP': 'MANGLER_TEKST',
  'application.title.stegvisning.samtykke_offentlig_AFP': 'MANGLER_TEKST',
  'application.title.stegvisning.samtykke': 'Samtykke - Penjonskalkulator',
  'application.title.stegvisning.uventet_feil':
    'Uventa feil - Pensjonskalkulator',
  'application.title.stegvisning.kalkulator_virker_ikke': 'MANGLER_TEKST',
  'application.title.securityLevel_feil': 'MANGLER_TEKST',
  'application.title.beregning': 'Utrekning - Pensjonskalkulator',
  'application.title.forbehold': 'Atterhald - Pensjonskalkulator',
  'application.title.personopplysninger':
    'Personopplysningar i enkel kalkulator Pensjonskalkulator',
  'application.global.external_link': 'opnar i ei ny fane',
  'application.global.retry': 'Prøv på nytt',
  'pageframework.title': 'Pensjonskalkulator',
  'pageframework.loading': 'Vent litt medan vi hentar informasjon',
  'error.securityLevel.title': 'MANGLER_TEKST',
  'error.securityLevel.ingress': 'MANGLER_TEKST',
  'error.securityLevel.primary_button': 'MANGLER_TEKST',
  'error.securityLevel.secondary_button': 'MANGLER_TEKST',
  'error.fullmakt.title': 'MANGLER_TEKST',
  'error.fullmakt.ingress': 'MANGLER_TEKST',
  'error.fullmakt.bytt_bruker': 'MANGLER_TEKST',
  'error.global.title': 'Oops! Det har oppstått ein uventa feil.',
  'error.global.ingress': 'Vi jobbar med å rette feilen. Prøv igjen seinare.',
  'error.global.button': 'Avbryt',
  'error.du_kan_ikke_bruke_enkel_kalkulator':
    'Du kan dessverre ikkje bruke denne kalkulatoren',
  'error.404.title': 'Oops! Sida du ser etter er ikkje å finne.',
  'error.404.list_item1':
    'Viss du skreiv inn adressa direkte i nettlesaren kan du sjekke om ho er stava riktig.',
  'error.404.list_item2':
    'Viss du klikka på ei lenkje er ho feil eller utdatert.',
  'error.404.button.link_1': 'Gå til pensjonskalkulator',
  'error.404.button.link_2': 'Les om pensjon',
  'error.virker_ikke.title': 'MANGLER_TEKST',
  'error.virker_ikke.ingress': 'MANGLER_TEKST',
  'error.virker_ikke.link': 'MANGLER_TEKST',
  'error.virker_ikke.button': 'MANGLER_TEKST',
  'error.apoteker_warning': 'MANGELR_TEKST',
  'landingsside.for.deg.som.kan.logge.inn': 'MANGLER_TEKST',
  'landingsside.for.deg.foedt.foer.1963': 'For deg født før 1963',
  'landingsside.du.maa.bruke.detaljert':
    'Du må bruke vår detaljerte kalkulator. Der får du rekna ut alderspensjonen frå folketrygda (Nav), avtalefesta pensjon (AFP) og pensjonsavtalar (arbeidsgjevarar og sparing)',
  'landingsside.velge_mellom_detaljert_og_enkel':
    'I pensjonskalkulatoren kan du få et estimat på',
  'landingsside.button.enkel_kalkulator_utlogget':
    'Logg inn i pensjonskalkulator',
  'landingsside.button.enkel_kalkulator': 'Enkel kalkulator',
  'landingsside.text.uinnlogget_kalkulator': 'Uinnlogga kalkulator',
  'landingsside.button.uinnlogget_kalkulator': 'Uinnlogga kalkulator',
  'landingsside.body.uinnlogget_kalkulator':
    'For deg som ikkje kan logge inn på nav.no. Kalkulatoren hentar ikkje inn og lagrar ikkje  opplysningar om deg. Du må sjølv finne og gje opp alle opplysningane til kalkulatoren, og du får kun svar på kva du kan rekne med å få i alderspensjon frå folketrygda (Nav).',
  'landingsside.link.personopplysninger':
    'Personopplysningar som vert brukt i enkel kalkulator',
  'stegvisning.radio_ja': 'Ja',
  'stegvisning.radio_nei': 'Nei',
  'stegvisning.neste': 'Neste',
  'stegvisning.tilbake': 'Tilbake',
  'stegvisning.avbryt': 'Avbryt',
  'stegvisning.tilbake_start': 'Tilbake til start',
  'stegvisning.tilbake_start.modal.title': 'MANGLER_TEKST',
  'stegvisning.tilbake_start.modal.bekreft': 'MANGLER_TEKST',
  'stegvisning.tilbake_start.modal.avbryt': 'MANGLER_TEKST',
  'stegvisning.fremtidigvedtak.alert': 'MANGLER_TEKST',
  'stegvisning.start.title': 'Hei',
  'stegvisning.start.endring.ingress_1a': 'MANGLER_TEKST',
  'stegvisning.start.endring.ingress_1b.uten_fremtidig': 'MANGLER_TEKST',
  'stegvisning.start.endring.ingress_1b.med_fremtidig': 'MANGLER_TEKST',
  'stegvisning.start.ingress.pre2025_offentlig_afp': 'MANGLER_TEKST',
  'stegvisning.start.endring.ingress.pre2025_offentlig_afp_fremtidig':
    'MANGLER_TEKST',
  'stegvisning.start.ingress': 'MANGLER_TEKST',
  'stegvisning.start.list_item1': 'MANGLER_TEKST',
  'stegvisning.start.list_item2': 'MANGLER_TEKST',
  'stegvisning.start.list_item3': 'MANGLER_TEKST',
  'stegvisning.start.endring.ingress_2': 'MANGLER_TEKST',
  'stegvisning.start.ingress_2': 'MANGLER_TEKST',
  'stegvisning.start.button': 'Kom i gang',
  'stegvisning.start.link':
    'Personopplysningar som vert brukt i enkel kalkulator',
  'stegvisning.start_brukere_fyllt_75.title': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.ingress': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.button': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.avbryt': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.title': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.ingress': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.radio_label': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.radio_label.description': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.radio_ja': 'Ja',
  'stegvisning.utenlandsopphold.radio_nei': 'Nei',
  'stegvisning.utenlandsopphold.validation_error':
    'Du må svare på om du har budd eller jobba utanfor Noreg i meir enn fem år etter fylte 16 år.',
  'stegvisning.utenlandsopphold.mangler_opphold.validation_error':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.ingress.bottom': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.title': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description.periode':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description.periode.varig_opphold':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet.ja':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet.nei':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.button.legg_til': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.button.legg_til_nytt':
    'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.button.endre': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.oppholdene.button.slette': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.title': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.legg_til': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.oppdater': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.avbryt': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.avbryt_endring':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.land.label': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.label': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.description':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.radio_ja':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.radio_nei':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.label': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.description':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.label': 'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.description':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.land.validation_error':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.arbeidet_utenlands.validation_error':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.dato.validation_error.format':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.dato.validation_error.after_max':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.validation_error.required':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.validation_error.before_min':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.validation_error.before_min':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.validation_error.required':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.ikke_avtaleland':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.ulike_land':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.bostatus':
    'MANGLER_TEKST',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.jobbstatus':
    'MANGLER_TEKST',
  'utenlandsopphold.slette_modal.title': 'MANGLER_TEKST',
  'utenlandsopphold.slette_modal.button.avbryt': 'MANGLER_TEKST',
  'utenlandsopphold.slette_modal.button.slett': 'MANGLER_TEKST',
  'stegvisning.samtykke_pensjonsavtaler.title': 'Pensjonen din',
  'stegvisning.samtykke_pensjonsavtaler.ingress': 'MANGLER_TEKST',
  'stegvisning.samtykke_pensjonsavtaler.radio_label':
    'Skal vi hente dine pensjonsavtalar?',
  'stegvisning.samtykke_pensjonsavtaler.radio_description': 'MANGLER_TEKST',
  'stegvisning.samtykke_pensjonsavtaler.radio_ja': 'Ja',
  'stegvisning.samtykke_pensjonsavtaler.radio_nei': 'Nei, hald fram utan',
  'stegvisning.samtykke_pensjonsavtaler.validation_error':
    'Du må svare på om du vil at vi skal hente dine pensjonsavtalar.',
  'stegvisning.afp.title': 'Avtalefesta pensjon',
  'stegvisning.afp.ingress':
    'For å få avtalefesta pensjon (AFP) må arbeidsgjevaren din ha ein slik avtale og du må kvalifisere til å få den.',
  'stegvisning.afp.readmore_offentlig_list_title': 'AFP i offentleg sektor:',
  'stegvisning.afp.radio_label': 'Har du rett til AFP?',
  'stegvisning.afp.radio_ja_offentlig': 'Ja, i offentleg sektor',
  'stegvisning.afp.radio_ja_privat': 'Ja, i privat sektor',
  'stegvisning.afp.radio_nei': 'Nei',
  'stegvisning.afp.radio_vet_ikke': 'Veit ikkje',
  'stegvisning.afp.alert_vet_ikke':
    'Er du usikker på om du har rett til AFP, bør du sjekke med arbeidsgjevaren din.',
  'stegvisning.afp.validation_error': 'Du må svare på om du har rett til AFP.',
  'stegvisning.ufoere.title': 'MANGLER_TEKST',
  'stegvisning.ufoere.info': 'MANGLER_TEKST',
  'stegvisning.ufoere.ingress': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.title': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.ingress': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.radio_label': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.radio_description': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.radio_ja': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.radio_nei': 'MANGLER_TEKST',
  'stegvisning.samtykke_offentlig_afp.validation_error': 'MANGLER_TEKST',
  'stegvisning.sivilstand.title': 'Din sivilstand',
  'stegvisning.sivilstand.ingress_ukjent': 'MANGLER_TEKST',
  'stegvisning.sivilstand.ingress_1': 'Du er registrert som ',
  'stegvisning.sivilstand.ingress_2':
    'i Folkeregisteret. Har du sambuar eller ektefelle kan det påverke utrekninga.',
  'stegvisning.sivilstand.select_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.select_description_ukjent': 'MANGLER_TEKST',
  'stegvisning.sivilstand.select_description': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarPensjon_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarPensjon_description': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarInntektOver2G_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarInntektOver2G_description':
    'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_label': 'Har du sambuar eller ektefelle?',
  'stegvisning.sivilstand.radio_ja': 'Ja',
  'stegvisning.sivilstand.radio_nei': 'Nei',
  'stegvisning.sivilstand.select_validation_error': 'MANGELR_TEKST',
  'stegvisning.sivilstand.epsHarPensjon.validation_error': 'MANGLER_TEKST',
  'stegvisning.sivilstand.epsHarInntektOver2G.validation_error':
    'MANGLER_TEKST',
  'agepicker.validation_error.aar': 'MANGLER_TEKST',
  'agepicker.validation_error.maaneder': 'MANGLER_TEKST',
  'string.og': 'og',
  'alder.md': 'md.',
  'alder.maaned': 'måned',
  'alder.maaneder': 'månedar',
  'alder.aar': 'år',
  'alder.aar_livsvarig': 'år (livsvarig)',
  'afp.offentlig': 'Offentleg',
  'afp.privat': 'Privat',
  'afp.nei': 'Nei',
  'afp.vet_ikke': 'Veit ikkje',
  'sivilstand.GIFT': 'Gift',
  'sivilstand.UGIFT': 'Ugift',
  'sivilstand.REGISTRERT_PARTNER': 'Registrert partnar',
  'sivilstand.ENKE_ELLER_ENKEMANN': 'Enkje/enkjemann',
  'sivilstand.SKILT': 'Skild',
  'sivilstand.SEPARERT': 'Separert',
  'sivilstand.SEPARERT_PARTNER': 'Separert partnar',
  'sivilstand.SAMBOER': 'Sambuar',
  'sivilstand.SKILT_PARTNER': 'Skild partnar',
  'sivilstand.GJENLEVENDE_PARTNER': 'Attlevande partnar',
  'sivilstand.med_samboer': 'med sambuar',
  'sivilstand.uten_samboer': 'utan sambuar',
  'tidligstmuliguttak.ingress_1':
    'Di opptening gjer at du tidlegast kan ta ut 100 % alderspensjon når du er ',
  'tidligstmuliguttak.1963.ingress_2':
    ' Jo lenger du ventar, dess meir får du i året.',
  'tidligstmuliguttak.1964.ingress_2': 'MANGLER_TEKST',
  'tidligstmuliguttak.pre2025OffentligAfp.ingress': 'MANGLER_TEKST',
  'tidligstmuliguttak.pre2025OffentligAfp.avansert_link': 'MANGLER_TEKST',
  'tidligstmuliguttak.info_omstillingsstoenad_og_gjenlevende': 'MANGLER_TEKST',
  'tidligstmuliguttak.error': 'MANGLER_TEKST',
  'omufoeretrygd.hel.ingress': 'MANGLER_TEKST',
  'omufoeretrygd.gradert.ingress': 'MANGLER_TEKST',
  'omufoeretrygd.gradert.ingress.afp': 'MANGLER_TEKST',
  'omufoeretrygd.avansert_link': 'MANGLER_TEKST',
  'velguttaksalder.title': 'Kor tid vil du ta ut alderspensjon?',
  'velguttaksalder.endring.title': 'MANGLER_TEKST',
  'velguttaksalderafp.title': 'MANGLER_TEKST',
  'beregning.intro.title': 'MANGLER_TEKST',
  'beregning.intro.title.endring': 'MANGLER_TEKST',
  'beregning.intro.description_1': 'MANGLER_TEKST',
  'beregning.intro.description_1.endring': 'MANGLER_TEKST',
  'beregning.intro.description_2.gradert_UT.med_afp': 'MANGLER_TEKST',
  'beregning.intro.description_2.gradert_UT.uten_afp': 'MANGLER_TEKST',
  'beregning.intro.description_2.hel_UT': 'MANGLER_TEKST',
  'beregning.pdf.ingress': 'MANGLER_TEKST',
  'beregning.pdf.button': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.description': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.om_valget_link': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.uten_afp.label':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.med_afp.label':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.afp_etterfulgt_av_ap.title': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.med_afp.title': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.med_afp.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.pre2025_offentlig_afp.alert': 'MANGLER_TEKST',
  'beregning.toggle.enkel': 'MANGLER_TEKST',
  'beregning.toggle.avansert': 'MANGLER_TEKST',
  'beregning.loading': 'Vent litt medan vi reknar ut pensjonen din',
  'beregning.error':
    'Vi klarte dessverre ikkje å rekne ut pensjonen din akkurat nå.',
  'beregning.livsvarig': 'MANGLER_TEKST',
  'beregning.lav_opptjening.aar':
    'Du har ikkje høg nok opptening til å kunne starte uttak ved {startAar} år{startMaaned}. Prøv ein høgare alder.',
  'beregning.button.faerre_aar': 'Færre år',
  'beregning.button.flere_aar': 'Fleire år',
  'beregning.pensjonsavtaler.alert.endring': 'MANGLER_TEKST',
  'beregning.pensjonsavtaler.alert.stoettes_ikke': 'MANGLER_TEKST',
  'beregning.pensjonsavtaler.alert.privat.error': 'MANGLER_TEKST',
  'beregning.pensjonsavtaler.alert.offentlig.error': 'MANGLER_TEKST',
  'beregning.pensjonsavtaler.alert.privat_og_offentlig.error': 'MANGLER_TEKST',
  'beregning.pensjonsavtaler.alert.avtaler_foer_alder':
    'Du har pensjonsavtalar som startar før valgt alder. Sjå detaljar i grunnlaget under.',
  'beregning.title': 'MANGLER_TEKST',
  'beregning.alert.inntekt': 'MANGLER_TEKST',
  'beregning.highcharts.informasjon_klikk': 'MANGLER_TEKST',
  'beregning.highcharts.title': 'MANGLER_TEKST',
  'beregning.highcharts.ingress': 'MANGLER_TEKST',
  'beregning.highcharts.alt_tekst': 'MANGLER_TEKST',
  'beregning.highcharts.xaxis': 'Årleg inntekt og pensjon etter uttak',
  'beregning.highcharts.yaxis': 'Kroner',
  'beregning.highcharts.yaxis.mobile': 'Tusen kroner',
  'beregning.highcharts.serie.inntekt.name': 'Pensjonsgjevande inntekt',
  'beregning.highcharts.serie.tp.name':
    'Pensjonsavtalar (arbeidsgjevarar m.m.)',
  'beregning.highcharts.serie.afp.name': 'AFP (Avtalefesta pensjon)',
  'beregning.highcharts.serie.alderspensjon.name': 'Alderspensjon (Nav)',
  'beregning.highcharts.tooltip.inntekt': 'Inntekt når du er',
  'beregning.highcharts.tooltip.pensjon': 'Pensjon når du er',
  'beregning.highcharts.tooltip.inntekt_og_pensjon':
    'Inntekt og pensjon når du er',
  'beregning.tabell.lukk': 'Lukk tabell av utrekninga',
  'beregning.tabell.vis': 'Vis tabell av utrekninga',
  'beregning.tabell.sum': 'Sum',
  'beregning.detaljer.lukk': 'MANGLER_TEKST',
  'beregning.detaljer.vis': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.heltUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.gradertUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.afp.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.pre2025OffentligAfp.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpPrivat.heltUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpPrivat.gradertUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpOffentlig.uttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.kap19.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.kap20.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.afpPrivat.table.title':
    'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.pre2025OffentligAfp.table.title':
    'MANGLER_TEKST',
  'beregning.avansert.link.endre_valgene_dine': 'MANGLER_TEKST',
  'beregning.avansert.link.endre_avanserte_valg': 'MANGLER_TEKST',
  'beregning.avansert.link.om_vilkaar_for_afp': 'MANGLER_TEKST',
  'beregning.avansert.endring_banner.title': 'MANGLER_TEKST',
  'beregning.avansert.endring_banner.kr_md': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.table_title': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.box_title': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.afp': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.pensjonsavtaler': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.alderspensjon': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.sum': 'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_frem_til_endring.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.description_ufoere':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.description': 'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.endring.description': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak.description.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.validation_error': 'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.ufoeretrygd.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_helt_uttak.beloep.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.ufoeretrygd.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.description.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_afp.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.beloep.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt.button': 'MANGLER_TEKST',
  'beregning.avansert.rediger.agepicker.validation_error': 'MANGLER_TEKST',
  'beregning.avansert.rediger.agepicker.grad.validation_error': 'MANGLER_TEKST',
  'beregning.avansert.rediger.agepicker.afp.validation_error': 'MANGLER_TEKST',
  'beregning.avansert.rediger.agepicker.validation_error.maxAlder':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.heltuttak.agepicker.label': 'MANGLER_TEKST',
  'beregning.avansert.button.beregn': 'MANGLER_TEKST',
  'beregning.avansert.button.beregn.endring': 'MANGLER_TEKST',
  'beregning.avansert.button.oppdater': 'MANGLER_TEKST',
  'beregning.avansert.button.nullstill': 'MANGLER_TEKST',
  'beregning.avansert.button.avbryt': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.title': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.endring.title': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.button.avslutt': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.endring.button.avslutt': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.button.avbryt': 'MANGLER_TEKST',
  'beregning.avansert.alert.vilkaarsproevning.afp_inntekt_maaned_foer_uttak':
    'MANGLER_TEKST',
  'beregning.avansert.alert.afp_inntekt_maaned_foer_uttak': 'MANGLER_TEKST',
  'beregning.avansert.alert.afp_inntekt_maaned_foer_uttak.link.text':
    'MANGLER_TEKST',
  'beregning.endring.alert.uttaksdato': 'MANGLER_TEKST',
  'beregning.endring.rediger.title': 'MANGLER_TEKST',
  'beregning.endring.rediger.vedtak_status': 'MANGLER_TEKST',
  'beregning.endring.rediger.vedtak_grad_status': 'MANGLER_TEKST',
  'beregning.endring.rediger.vedtak_betaling_status': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.intro': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.intro.ikke_nok_opptjening': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.intro.optional': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.heltUttak': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.gradertUttak': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.heltOgGradertUttak': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.medAFP.intro': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.gradertUttak':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.heltOgGradertUttak':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.heltOgGradertUttak100':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.ikkeNokOpptjening':
    'MANGLER_TEKST',
  'grunnlag.title': 'Grunnlaget for utrekninga',
  'grunnlag.endring.title': 'MANGLER_TEKST',
  'maanedsbeloep.title': 'MANGLER_TEKST',
  'grunnlag.uttaksgrad.title': 'Uttaksgrad',
  'grunnlag.uttaksgrad.avansert_link': 'MANGLER_TEKST',
  'grunnlag.uttaksgrad.ingress':
    'Denne utrekninga syner 100 % uttak av alderspensjon. I avansert kalkulator får du rekna ut alderspensjon med andre uttaksgrader (20 %, 40 %, 50 %, 60 % og 80 %). Du kan jobbe så mykje du vil ved sida av pensjon sjølv om du har teke ut 100 %.',
  'grunnlag.inntekt.title': 'Inntekt',
  'grunnlag.inntekt.ingress':
    'Beløpet er di siste pensjonsgjevande årsinntekt (frå {aarsinntekt}) frå Skatteetaten. Inntekta vert brukt som di framtidige inntekt fram til du startar uttak av pensjon. Ynskjer du å endre framtidig inntekt, må du bruke <detaljertKalkulatorLink>detaljert pensjonskalkulator</detaljertKalkulatorLink>. Du kan òg legge inntekta i tillegg til pensjonsbehaldninga di i',
  'grunnlag.inntekt.ingress.endring':
    'Beløpet er di siste pensjonsgjevande årsinntekt (frå {aarsinntekt}) frå Skatteetaten. Inntekta vert brukt som di framtidige inntekt fram til du startar uttak av pensjon. Ynskjer du å endre framtidig inntekt, må du bruke <detaljertKalkulatorLink>detaljert pensjonskalkulator</detaljertKalkulatorLink>',
  'grunnlag.inntekt.info_om_inntekt': 'Kva er pensjonsgjevande inntekt?',
  'grunnlag.inntekt.info_om_inntekt.lukk': 'Lukk',
  'grunnlag.sivilstand.title': 'Sivilstand',
  'grunnlag.sivilstand.title.error': 'Kunne ikkje hentast',
  'grunnlag.sivilstand.ingress':
    'Viss du har låg opptening kan storleiken på alderspensjonen din avhenge av om du bur åleine eller samen med andre.{br}{br}<garantiPensjonLink>Om garantipensjon og satser</garantiPensjonLink>',
  'grunnlag.opphold.title.mindre_enn_5_aar': 'MANGLER_TEKST',
  'grunnlag.opphold.title.mer_enn_5_aar': 'MANGLER_TEKST',
  'grunnlag.opphold.title.for_lite_trygdetid': 'MANGLER_TEKST',
  'grunnlag.opphold.title.endring': 'MANGLER_TEKST',
  'grunnlag.opphold.value.mindre_enn_5_aar': 'MANGLER_TEKST',
  'grunnlag.opphold.value.mer_enn_5_aar': 'MANGLER_TEKST',
  'grunnlag.opphold.value.for_lite_trygdetid': 'MANGLER_TEKST',
  'grunnlag.opphold.value.endring': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.endre_opphold': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.endre_opphold.link': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.mindre_enn_5_aar': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.for_lite_trygdetid': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.endring': 'MANGLER_TEKST',
  'grunnlag.opphold.ingress.trygdetid': 'MANGLER_TEKST',
  'grunnlag.opphold.bunntekst': 'MANGLER_TEKST',
  'grunnlag.opphold.avbryt_modal.title': 'MANGLER_TEKST',
  'grunnlag.opphold.avbryt_modal.bekreft': 'MANGLER_TEKST',
  'grunnlag.opphold.avbryt_modal.avbryt': 'MANGLER_TEKST',
  'grunnlag.alderspensjon.title': 'Alderspensjon',
  'grunnlag.alderspensjon.value': 'Folketrygden (Nav)',
  'grunnlag.alderspensjon.ingress': 'MANGLER_TEKST',
  'grunnlag.alderspensjon.endring.ingress':
    'Alderspensjon vert rekna ut frå pensjonsbehaldninga di i folketrygda. Viss du fortset å ha inntekt samstundes med at du tek ut pensjon, vil alderspensjonen din auke.',
  'grunnlag.alderspensjon.endring.ingress.pensjonsbeholdning':
    '{br}{br}MANGLER_TEKST: {sum} kr',
  'grunnlag.alderspensjon.ingress.link':
    '{br}{br}<dinPensjonBeholdningLink>Di pensjonsopptening</dinPensjonBeholdningLink> {br}{br}<alderspensjonsreglerLink>Om reglane for alderspensjon</alderspensjonsreglerLink>',
  'grunnlag.afp.title': 'AFP',
  'grunnlag.afp.ikke_beregnet': 'MANGLER_TEKST',
  'grunnlag.afp.endring': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.null': '-',
  'grunnlag.afp.ingress.overgangskull': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.overgangskull.ufoeretrygd_eller_ap': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig.endring': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig_utilgjengelig': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_privat':
    'Nav har ikkje vurdert om du fyller inngangsvilkåra for å få AFP, men i utrekninga føreset vi at du gjer det. Les meir om vilkåra for AFP hos <afpLink>Fellesordningen for AFP</afpLink>.',
  'grunnlag.afp.ingress.ja_privat.endring': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_privat.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.vet_ikke':
    'Er du er usikker på om du har rett til AFP bør du spørja arbeidsgjevaren din. AFP kan påverke kor tid du kan ta ut alderspensjon.',
  'grunnlag.afp.ingress.vet_ikke.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.nei':
    'Har du starta i jobb hos en arbeidsgjevar som har avtale om AFP, tilrår vi at du gjer ei <goToStart>ny utrekning</goToStart>.',
  'grunnlag.afp.ingress.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.70prosentregel': 'MANGLER_TEKST',
  'grunnlag.afp.avkortet.til.70.prosent': 'MANGLER_TEKST',
  'grunnlag.afp.link.text': 'MANGLER_TEKST',
  'grunnlag.forbehold.ingress_1':
    'Pensjonen er rekna ut med opplysningane vi har om deg og opplysningane du har lagt inn. Utrekninga er gjort med gjeldande regelverk. Dette er ei førebels utrekning av kva du kan vente å få i pensjon. ',
  'grunnlag.forbehold.link': 'Alle atterhald',
  'grunnlag.forbehold.title': 'Atterhald',
  'savnerdunoe.title': 'MANGLER_TEKST',
  'savnerdunoe.title.endring': 'MANGLER_TEKST',
  'savnerdunoe.ingress': 'MANGLER_TEKST',
  'savnerdunoe.ingress.endring': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.open.button': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.title': 'MANGLER_TEKST',
  'pensjonsavtaler.fra_og_med_forklaring': 'MANGLER_TEKST',
  'pensjonsavtaler.private.title.ingen': 'MANGLER_TEKST',
  'pensjonsavtaler.private.ingress.norsk_pensjon':
    'Alle avtalar frå privat sektor vert henta frå <norskPensjonLink>Norsk Pensjon</norskPensjonLink>. Nav er ikkje ansvarleg for beløpa som er oppgitt. Du kan ha andre avtalar enn det som fins i Norsk Pensjon. Kontakt aktuell pensjonsordning.{br}{br}Vi kan ikkje hente pensjonsavtaler frå offentleg sektor. Sjekk aktuell tenestepensjonsordning.',
  'pensjonsavtaler.private.ingress.error.pensjonsavtaler':
    'Vi klarte ikkje å hente pensjonsavtalane dine frå Norsk Pensjon. Prøv igjen seinare.',
  'pensjonsavtaler.private.ingress.error.pensjonsavtaler.partial':
    'Vi klarte ikkje å hente alle pensjonsavtalane dine frå Norsk Pensjon. Prøv igjen seinare.',
  'pensjonsavtaler.ingress.error.samtykke_ingress':
    'Du har ikkje samtykka til å hente inn pensjonsavtalar. ',
  'pensjonsavtaler.ingress.error.samtykke_link_1': 'Start ei ny utrekning',
  'pensjonsavtaler.ingress.error.samtykke_link_2':
    'viss du ynskjer å få dette i utrekninga.',
  'pensjonsavtaler.ingress.ingen': 'Vi fant ingen pensjonsavtalar.',
  'alder.livsvarig': 'Livsvarig frå og med',
  'pensjonsavtaler.tabell.title.left': 'Avtalar',
  'pensjonsavtaler.tabell.title.right': 'Årleg beløp',
  'pensjonsavtaler.title': 'Pensjonsavtalar',
  'pensjonsavtaler.offentligtp.title': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.er_medlem_annen_ordning': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.error': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.teknisk_feil': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.empty': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.subtitle.spk':
    'Alderspensjon frå Statens pensjonskasse (SPK)',
  'pensjonsavtaler.offentligtp.subtitle.klp':
    'Alderspensjon frå Kommunal Landspensjonskasse (KLP)',
  'pensjonsavtaler.offentligtp.spk.afp_ja': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.spk.afp_nei.med_betinget': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.spk.afp_nei.uten_betinget': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.spk.afp_vet_ikke': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.klp.afp_ja': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.klp.afp_nei+vetikke': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.description': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.description.ufoere': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.paragraph': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.validation_error.required':
    'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.validation_error.type':
    'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.textfield.validation_error.max': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.button': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.ingress_2': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.open.button.legg_til':
    'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.open.button.endre': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.slette': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.title': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.textfield.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_afp_modal.textfield.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.textfield.description':
    'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.agepicker.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.legg_til': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.endre': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.open.link': 'Kva er pensjonsgjevande inntekt?',
  'inntekt.info_om_inntekt.intro': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.subtitle_1': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.list_item1': 'All lønsinntekt for lønstakarar',
  'inntekt.info_om_inntekt.list_item2':
    'Personinntekt frå næring frå sjølvstendige',
  'inntekt.info_om_inntekt.list_item3': 'Foreldrepengar',
  'inntekt.info_om_inntekt.list_item4': 'Sjukepengar',
  'inntekt.info_om_inntekt.list_item5': 'Dagpengar',
  'inntekt.info_om_inntekt.list_item6': 'Arbeidsavklaringspengar',
  'inntekt.info_om_inntekt.list_item7': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.list_item8': 'Omsorgsstønad',
  'inntekt.info_om_inntekt.list_item9':
    'Fosterheimsgodtgjersle (den delen som utgjer arbeidsgodtgjersle)',
  'inntekt.info_om_inntekt.subtitle_2': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item1': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item2': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item3': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item4': 'MANGLER_TEKST',
  'inntekt.info_om_inntekt.ingress':
    'Pensjonsgjvande inntekt verkar inn på retten til storleiken på alderspensjonen og andre pensjonsytingar. Pensjonsgjevande inntekt vert rekna ut av Skatteetaten.{br}{br}Uføretrygd gjer opptening til alderspensjon, men vert ikkje rekna som pensjonsgjevande inntekt.',
  'forbehold.title': 'Atterhald',
  'showmore.vis_mindre': 'Vis mindre',
  'showmore.vis_mer': 'Vis meir',
  'link.telefon_pensjon': '55 55 33 34',
}
